import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function Complaints() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Complaints policy"} />
      <MarkdownBlock markdown={TextBlocks.COMPLAINTS_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
